export enum SCRIPT_TYPE {
  file = 'text/javascript',
  inner = 'inner'
}
